import { render, staticRenderFns } from "./PopoverBillingFormatRadioList.vue?vue&type=template&id=b93451dc"
import script from "./PopoverBillingFormatRadioList.vue?vue&type=script&lang=js"
export * from "./PopoverBillingFormatRadioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports